/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of entity represented by this business.
 */
export const BusinessType = {
  SoleProprietorship: "soleProprietorship",
  UnincorporatedAssociation: "unincorporatedAssociation",
  Trust: "trust",
  PublicCorporation: "publicCorporation",
  PrivateCorporation: "privateCorporation",
  Llc: "llc",
  Partnership: "partnership",
  UnincorporatedNonProfit: "unincorporatedNonProfit",
  IncorporatedNonProfit: "incorporatedNonProfit",
  GovernmentEntity: "governmentEntity",
} as const;
/**
 * The type of entity represented by this business.
 */
export type BusinessType = ClosedEnum<typeof BusinessType>;

/** @internal */
export const BusinessType$inboundSchema: z.ZodNativeEnum<typeof BusinessType> =
  z.nativeEnum(BusinessType);
/** @internal */
export const BusinessType$outboundSchema: z.ZodNativeEnum<typeof BusinessType> =
  BusinessType$inboundSchema;
